import { useContext } from "react"
import { get } from "lodash"
import { useDispatch, useSelector } from "react-redux"
import PreferenceContext from "hooks/preferences"
import { Creators as PreferencesCreators } from "model/preferences"

export function useLastPreferenceRedirect() {
  const context = useContext(PreferenceContext)
  const dispatch = useDispatch()
  const lastPreferenceRedirect = useSelector(state => get(state, "global.preferences.lastPreferenceRedirect"))

  return {
    lastPreferenceRedirect,
    setLastPreferenceRedirect: (preferenceSubType, redirectedTo, defaultRedirectTo) => dispatch(PreferencesCreators.lastPreferenceRedirect(`${context.type}.${preferenceSubType}`, redirectedTo, defaultRedirectTo)),
  }
}
